<div fxLayout="column" fxLayoutGap="8px" *ngIf="parametersErrors$  | async as errors">

  <button mat-raised-button (click)="printAll(errors)">PRINT ALL ON CONSOLE</button>

  <mat-card *ngFor="let error of errors">
    <mat-card-header>
      <mat-card-title>
        {{error.dataPath}}
        <small>({{error.keyword}})</small>
      </mat-card-title>
      <mat-card-subtitle>{{error.schemaPath}}</mat-card-subtitle>
    </mat-card-header>
    <mat-card-content>
      <p>{{error.data | json}}</p>
      <p>{{error.message}}</p>
      <pre>{{error.params | json}}</pre>
    </mat-card-content>
  </mat-card>
</div>
